import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { parseByTag, parseTagNames } from '../useDocumentationV3/parsers';
import SwaggerParser from '@apidevtools/swagger-parser';
const useAction = (actionFn) => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => {
      return dispatch(actionFn(...args));
    },
    [dispatch]
  );
};

export const ACTION_TYPE = 'GET_DOCUMENTATION_V3';

export const useDocumentationV3 = (options) => {
  const result = useSelector((state) => {
    return state[ACTION_TYPE];
  });
  const action = useAction((args) => {
    const eapm = window.elasticApm;
    if (eapm) {
      window.elasticApm.startTransaction(ACTION_TYPE, 'http-request', {
        managed: true,
      });
    }
    const { service } = args;
    let documentationApiUrl = config('DOCUMENTATION_API_URL_SC');

    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_CALLED` });
      SwaggerParser.dereference(`${documentationApiUrl}${service}.json`, {
        dereference: {
          circular: true, // Don't allow circular $refs
        },
      })
        .then((res) => {
          event('API_TRANSACTION', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('DOCUMENTATION_API_URL'),
              userInfo: args?.userInfo,
              method: 'GET',
              code: res.status,
              operationName: ACTION_TYPE,
              message: res.statusText,
            },
          });
          return res;
        })
        .then((res) => {
          const s = res;
          const pathsByTag = parseByTag(s, service);
          const tagNames = parseTagNames(pathsByTag);
          const data = {
            ...s,
            pathsByTag,
            tagNames,
            service,
          };

          dispatch({
            type: `${ACTION_TYPE}_COMPLETED`,
            payload: data,
          });
          if (options && options.onCompleted) {
            options.onCompleted(data);
          }
        })
        .catch((error) => {
          dispatch({
            type: `${ACTION_TYPE}_ERROR`,
            payload: error,
          });
          if (options && options.onError) {
            options.onError(error);
          }
        });

      event('API_TRANSACTION_ERROR', {
        fields: {
          appVersion: process.env.PACKAGE_VERSION,
          url: window.location.href,
          endpoint: config('DOCUMENTATION_API_URL'),
          userInfo: args?.userInfo,
          method: 'GET',
          operationName: ACTION_TYPE,
          // code: res.status,
          // message: res.statusText,
        },
      });
    };
  });

  return [result, action];
};
